import { useEffect, useRef } from 'react'

export function useScrollAnimation(className = 'anim-visible', threshold = 0.15) {
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add(className)
          observer.disconnect()
        }
      },
      { threshold }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [className, threshold])

  return ref
}

export function useScrollAnimateChildren(className = 'anim-visible', threshold = 0.1) {
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    const parent = ref.current
    if (!parent) return
    const children = Array.from(parent.children) as HTMLElement[]
    const observers: IntersectionObserver[] = []
    children.forEach((child, i) => {
      child.style.transitionDelay = `${i * 80}ms`
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            child.classList.add(className)
            obs.disconnect()
          }
        },
        { threshold }
      )
      obs.observe(child)
      observers.push(obs)
    })
    return () => observers.forEach(o => o.disconnect())
  }, [className, threshold])

  return ref
}